<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">Add Personnel</h5>
      <form [formGroup]="AddNewPerson">

        <input type="hidden" formControlName="id" />

        <br>
        <br>
        <h4>Personnel List</h4>
        <br>

        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Name (*)</label>
            <input formControlName="fname" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_fname().valid && get_Form_fname().touched" class="form-text text-muted MyErrorRedColor">Enter the first name.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Last Name (*)</label>
            <input formControlName="lname" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_lname().valid && get_Form_lname().touched" class="form-text text-muted MyErrorRedColor">Enter the last name.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Gender </label>
            <select class="custom-select" formControlName="sex">
              <option value="0">Select</option>
              <option value="1">Male</option>
              <option value="2">Female</option>
            </select>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Marital Status</label>
            <select class="custom-select" formControlName="vaziat_Tahol"  >
              <option value="0">Select</option>
              <option value="1">Married</option>
              <option value="2">Single</option>
            </select>
          </div>

        </div>
        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Province </label>
            <select class="custom-select" formControlName="ProvinceId"  (change)="ProvinceChange()">
              <option value="0">Select</option>
              <option *ngFor="let item of DataList_Province" [value]="item.code">{{item.title}}</option>
            </select>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Place of Issue</label>
            <select class="custom-select" formControlName="mahal_tavalod">
              <option value="0">Select</option>
              <option *ngFor="let item of DataList_City" [value]="item.id">{{item.title}}</option>
            </select>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">ID Document Number</label>
            <input formControlName="shomareh_Shenasnameh" type="number" class="form-control"  placeholder="Type here...">
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">ID Document Serial Number</label>
            <input formControlName="shomareh_Shenasnameh_Seri" type="text" class="form-control"  placeholder="Type here...">
          </div>

        </div>
        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">National ID (without leading zero)</label>
            <input formControlName="codeMeli" type="number" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_codeMeli().valid && get_Form_codeMeli().touched" class="form-text text-muted MyErrorRedColor">Enter the national ID.</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Insurance Number</label>
            <input formControlName="shomareh_bimeh" type="text" class="form-control"  placeholder="Type here...">
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Father</label>
            <input formControlName="name_Pedar" type="text" class="form-control"  placeholder="Type here...">
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Father Occupation</label>
            <input formControlName="shoghleh_Pedar" type="text" class="form-control"  placeholder="Type here...">
          </div>

        </div>

        <div class="row">

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">
              Mobile Number (without leading zero)
              <button (click)="OnAdd_shomareh_Hamreh()"  type="button" [disabled]="!get_Form_shomareh_Hamreh().valid || get_Form_shomareh_Hamreh().value =='' || get_Form_shomareh_Hamreh().value == null "  class="btn  btn-success" ><i class="fa  fa-plus-circle"></i> </button>
            </label>
            <input formControlName="shomareh_Hamreh" type="number" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_shomareh_Hamreh().valid && get_Form_shomareh_Hamreh().touched" class="form-text text-muted MyErrorRedColor">Enter the mobile number.</small>
            <table class="mb-0 table table-bordered table-3 text-center table-striped" *ngIf="Person_shomareh_Hamreh_Array.length>0">
              <tr class="bg-warning" *ngFor="let item of Person_shomareh_Hamreh_Array">
                  <td>
                    {{item.title}}
                  </td>
                  <td>
                    <a style="cursor: pointer;"  (click)="Person_shomareh_Hamreh_Delete(item.id)"><i class="fa fa-remove"></i> Delete </a>
                  </td>
              </tr>
            </table>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Housing </label>
            <select class="custom-select" formControlName="maskan"  >
              <option value="0">Select</option>
              <option value="1">Owned</option>
              <option value="2">Rented</option>
              <option value="3">Living with Relatives</option>
            </select>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">
              Email
              <button (click)="OnAdd_email()"  type="button" [disabled]="!get_Form_email().valid || get_Form_email().value =='' || get_Form_email().value == null "  class="btn  btn-success" ><i class="fa  fa-plus-circle"></i> </button>
            </label>
            <input formControlName="email" type="email" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_email().valid && get_Form_email().touched" class="form-text text-muted MyErrorRedColor">Enter the email address.</small>
            <table class="mb-0 table table-bordered table-3 text-center table-striped" *ngIf="Person_email_Array.length>0">
              <tr class="bg-warning" *ngFor="let item of Person_email_Array">
                  <td>
                    {{item.title}}
                  </td>
                  <td>
                    <a style="cursor: pointer;"  (click)="Person_email_Delete(item.id)"><i class="fa fa-remove"></i> Delete </a>
                  </td>
              </tr>
            </table>
          </div>



        </div>

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">
              Current Home Address
              <button (click)="OnAdd_address_Manzel()"  type="button" [disabled]="!get_Form_address_Manzel().valid || get_Form_address_Manzel().value =='' || get_Form_address_Manzel().value == null "  class="btn  btn-success" ><i class="fa  fa-plus-circle"></i> </button>
            </label>
            <input formControlName="address_Manzel" type="text" class="form-control"  placeholder="Type here...">
            <table class="mb-0 table table-bordered table-3 text-center table-striped" *ngIf="Person_address_Manzel_Array.length>0">
              <tr class="bg-warning" *ngFor="let item of Person_address_Manzel_Array">
                  <td>
                    {{item.title}}
                  </td>
                  <td>
                    <a style="cursor: pointer;"  (click)="Person_address_Manzel_Delete(item.id)"><i class="fa fa-remove"></i> Delete </a>
                  </td>
              </tr>
            </table>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">
              Postal Code
              <button (click)="OnAdd_codeposti()"  type="button" [disabled]="!get_Form_codeposti().valid || get_Form_codeposti().value =='' || get_Form_codeposti().value == null "  class="btn  btn-success" ><i class="fa  fa-plus-circle"></i> </button>
            </label>
            <input formControlName="codeposti" type="text" class="form-control"  placeholder="Type here...">
            <table class="mb-0 table table-bordered table-3 text-center table-striped" *ngIf="Person_codeposti_Array.length>0">
              <tr class="bg-warning" *ngFor="let item of Person_codeposti_Array">
                  <td>
                    {{item.title}}
                  </td>
                  <td>
                    <a style="cursor: pointer;"  (click)="Person_codeposti_Delete(item.id)"><i class="fa fa-remove"></i> Delete </a>
                  </td>
              </tr>
            </table>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">
              Phone
              <button (click)="OnAdd_tel()"  type="button" [disabled]="!get_Form_tel().valid || get_Form_tel().value =='' || get_Form_tel().value == null "  class="btn  btn-success" ><i class="fa  fa-plus-circle"></i> </button>
            </label>
            <input formControlName="tel" type="number" class="form-control"  placeholder="Type here...">
            <table class="mb-0 table table-bordered table-3 text-center table-striped" *ngIf="Person_tel_Array.length>0">
              <tr class="bg-warning" *ngFor="let item of Person_tel_Array">
                  <td>
                    {{item.title}}
                  </td>
                  <td>
                    <a style="cursor: pointer;"  (click)="Person_tel_Delete(item.id)"><i class="fa fa-remove"></i> Delete </a>
                  </td>
              </tr>
            </table>
          </div>

        </div>

        <div class="row" [hidden]="get_Form_Sex().value!='1'">

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Military Service Status</label>
            <select class="custom-select" formControlName="vaziat_Nazam_Vazifeh"  >
              <option value="0">Select</option>
              <option value="1">Completed</option>
              <option value="2">Temporary Exemption</option>
              <option value="3">Permanent Exemption</option>
            </select>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Military Service Status Description</label>
            <input formControlName="vaziat_Nazam_Vazifeh_Dsc" type="text" class="form-control"  placeholder="Type here...">
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">From Date </label>
            <input formControlName="vaziat_startDate" #vaziat_startDateInput type="text" class="form-control"  placeholder="Type here...">
            <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="vaziat_startDateInput"></ng-persian-datepicker>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">To Date </label>
            <input formControlName="vaziat_endDate" #vaziat_endDateInput type="text" class="form-control"  placeholder="Type here...">
            <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="vaziat_endDateInput"></ng-persian-datepicker>
          </div>

        </div>

        <div class="row" [hidden]="get_Form_vaziat_Tahol().value!='1'">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Spouse Name</label>
            <input formControlName="name_Hamsar" type="text" class="form-control"  placeholder="Type here...">
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Number of Children</label>
            <input formControlName="tedadFarzandan" type="number" class="form-control"  placeholder="Type here...">
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Spouse National ID (without leading zero) </label>
            <input formControlName="codeMeli_Hamsar" type="number" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_codeMeli_Hamsar().valid && get_Form_codeMeli_Hamsar().touched" class="form-text text-muted MyErrorRedColor">Enter the spouse national ID.</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">
              Spouse Mobile Number (without leading zero)
              <button (click)="OnAdd_shomareh_hamrah_Hamsar()"  type="button" [disabled]="!get_Form_shomareh_hamrah_Hamsar().valid || get_Form_shomareh_hamrah_Hamsar().value =='' || get_Form_shomareh_hamrah_Hamsar().value == null "  class="btn  btn-success" ><i class="fa  fa-plus-circle"></i> </button>
            </label>
            <input formControlName="shomareh_hamrah_Hamsar" type="number" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_shomareh_hamrah_Hamsar().valid && get_Form_shomareh_hamrah_Hamsar().touched" class="form-text text-muted MyErrorRedColor">Enter the spouse mobile number.</small>
            <table class="mb-0 table table-bordered table-3 text-center table-striped" *ngIf="Person_shomareh_hamrah_Hamsar_Array.length>0">
              <tr class="bg-warning" *ngFor="let item of Person_shomareh_hamrah_Hamsar_Array">
                  <td>
                    {{item.title}}
                  </td>
                  <td>
                    <a style="cursor: pointer;"  (click)="Person_shomareh_hamrah_Hamsar_Delete(item.id)"><i class="fa fa-remove"></i> Delete </a>
                  </td>
              </tr>
            </table>
          </div>

        </div>

        <div class="row" [hidden]="get_Form_vaziat_Tahol().value!='1'">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Spouse Education</label>
            <select class="custom-select" formControlName="tahsilat_Hamsar"  >
              <option value="0">Select</option>
              <option value="1">Middle School</option>
              <option value="2">High School Diploma</option>
              <option value="3">Associate Degree</option>
              <option value="4">Bachelor's Degree</option>
              <option value="5">Master's Degree</option>
              <option value="6">Doctorate</option>
            </select>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Spouse Date of Birth</label>
            <input formControlName="tarikh_Tavalod_Hamsar" #tarikh_Tavalod_HamsarInput type="text" class="form-control"  placeholder="Type here...">
            <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="tarikh_Tavalod_HamsarInput"></ng-persian-datepicker>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Spouse Occupation</label>
            <input formControlName="shoghleh_Hamsar" type="text" class="form-control"  placeholder="Type here...">
          </div>

        </div>

        <div class="row" >
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Date of Birth </label>
            <input formControlName="tarikh_Tavalod" #tarikh_Tavalod_Input type="text" class="form-control"  placeholder="Type here...">
            <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="tarikh_Tavalod_Input"></ng-persian-datepicker>
          </div>
        </div>

        <br>
        <br>
        <hr>
        <br>
        <h4>Upload Documents</h4>
        <br>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">
              National ID Card 1
              <button (click)="Remove_uploadcodemeli_Image1()"  type="button" *ngIf="Add_Record_Persone.codemeli_Image1"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_codemeli_Image1" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_codemeli_Image1" #file_codemeli_Image1 (change)="uploadcodemeli_Image1(file_codemeli_Image1.files)" type="file" class="form-control"  placeholder="Type here...">
            <img (click)="openModal(templateImage,Add_Record_Persone.codemeli_Image1)" *ngIf="Add_Record_Persone.codemeli_Image1" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{Add_Record_Persone.codemeli_Image1}}"/>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">
              National ID Card 2
              <button (click)="Remove_uploadcodemeli_Image2()"  type="button" *ngIf="Add_Record_Persone.codemeli_Image2"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_codemeli_Image2" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_codemeli_Image2" #file_codemeli_Image2 (change)="uploadcodemeli_Image2(file_codemeli_Image2.files)" type="file" class="form-control"  placeholder="Type here...">
            <img (click)="openModal(templateImage,Add_Record_Persone.codemeli_Image2)" *ngIf="Add_Record_Persone.codemeli_Image2" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{Add_Record_Persone.codemeli_Image2}}"/>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">
              ID Document 1
              <button (click)="Remove_uploadshenasNameh_Image1()"  type="button" *ngIf="Add_Record_Persone.shenasNameh_Image1"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_shenasNameh_Image1" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_shenasNameh_Image1" #file_shenasNameh_Image1 (change)="uploadshenasNameh_Image1(file_shenasNameh_Image1.files)" type="file" class="form-control"  placeholder="Type here...">
            <img (click)="openModal(templateImage,Add_Record_Persone.shenasNameh_Image1)" *ngIf="Add_Record_Persone.shenasNameh_Image1" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{Add_Record_Persone.shenasNameh_Image1}}"/>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">
              ID Document 2
              <button (click)="Remove_uploadshenasNameh_Image2()"  type="button" *ngIf="Add_Record_Persone.shenasNameh_Image2"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_shenasNameh_Image2" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_shenasNameh_Image2" #file_shenasNameh_Image2 (change)="uploadshenasNameh_Image2(file_shenasNameh_Image2.files)" type="file" class="form-control"  placeholder="Type here...">
            <img (click)="openModal(templateImage,Add_Record_Persone.shenasNameh_Image2)" *ngIf="Add_Record_Persone.shenasNameh_Image2" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{Add_Record_Persone.shenasNameh_Image2}}"/>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">
              ID Document 3
              <button (click)="Remove_uploadshenasNameh_Image3()"  type="button" *ngIf="Add_Record_Persone.shenasNameh_Image3"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_shenasNameh_Image3" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_shenasNameh_Image3" #file_shenasNameh_Image3 (change)="uploadshenasNameh_Image3(file_shenasNameh_Image3.files)" type="file" class="form-control"  placeholder="Type here...">
            <img (click)="openModal(templateImage,Add_Record_Persone.shenasNameh_Image3)" *ngIf="Add_Record_Persone.shenasNameh_Image3" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{Add_Record_Persone.shenasNameh_Image3}}"/>
          </div>

        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">
              Military Service Completion Card
              <button (click)="Remove_uploadkartPayan_Khadamt_Image()"  type="button" *ngIf="Add_Record_Persone.kartPayan_Khadamt_Image"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_kartPayan_Khadamt_Image" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_kartPayan_Khadamt_Image" #file_kartPayan_Khadamt_Image (change)="uploadkartPayan_Khadamt_Image(file_kartPayan_Khadamt_Image.files)" type="file" class="form-control"  placeholder="Type here...">
            <img (click)="openModal(templateImage,Add_Record_Persone.kartPayan_Khadamt_Image)" *ngIf="Add_Record_Persone.kartPayan_Khadamt_Image" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{Add_Record_Persone.kartPayan_Khadamt_Image}}"/>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">
              Criminal Record Form
              <button (click)="Remove_uploadform_soe_Pishineh_Image()"  type="button" *ngIf="Add_Record_Persone.form_soe_Pishineh_Image"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_form_soe_Pishineh_Image" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_form_soe_Pishineh_Image" #file_form_soe_Pishineh_Image (change)="uploadform_soe_Pishineh_Image(file_form_soe_Pishineh_Image.files)" type="file" class="form-control"  placeholder="Type here...">
            <img (click)="openModal(templateImage,Add_Record_Persone.form_soe_Pishineh_Image)" *ngIf="Add_Record_Persone.form_soe_Pishineh_Image" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{Add_Record_Persone.form_soe_Pishineh_Image}}"/>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">
              Personnel Photo
              <button (click)="Remove_uploadax_Personeli_Image()"  type="button" *ngIf="Add_Record_Persone.ax_Personeli_Image"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_ax_Personeli_Image" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_ax_Personeli_Image" #file_ax_Personeli_Image (change)="uploadax_Personeli_Image(file_ax_Personeli_Image.files)" type="file" class="form-control"  placeholder="Type here...">
            <img (click)="openModal(templateImage,Add_Record_Persone.ax_Personeli_Image)" *ngIf="Add_Record_Persone.ax_Personeli_Image" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{Add_Record_Persone.ax_Personeli_Image}}"/>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">
              Personnel Photo 2
              <button (click)="Remove_uploadax_Personeli_Image2()"  type="button" *ngIf="Add_Record_Persone.ax_Personeli_Image2"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_ax_Personeli_Image2" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_ax_Personeli_Image2" #file_ax_Personeli_Image2 (change)="uploadax_Personeli_Image2(file_ax_Personeli_Image2.files)" type="file" class="form-control"  placeholder="Type here...">
            <img (click)="openModal(templateImage,Add_Record_Persone.ax_Personeli_Image2)" *ngIf="Add_Record_Persone.ax_Personeli_Image2" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{Add_Record_Persone.ax_Personeli_Image2}}"/>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">
              Signature
              <button (click)="Remove_uploadax_Sign_Image()"  type="button" *ngIf="Add_Record_Persone.sign_image"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_ax_Sign_Image" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_ax_Sign_Image" #file_ax_Sign_Image (change)="uploadax_Sign_Image(file_ax_Sign_Image.files)" type="file" class="form-control"  placeholder="Type here...">
            <img (click)="openModal(templateImage,Add_Record_Persone.sign_image)" *ngIf="Add_Record_Persone.sign_image" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{Add_Record_Persone.sign_image}}"/>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">
              Interview Resume Form
              <button (click)="Remove_uploadform_reserve_mosahebeh_Image()"  type="button" *ngIf="Add_Record_Persone.form_reserve_mosahebeh_Image"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_form_reserve_mosahebeh_Image" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_form_reserve_mosahebeh_Image" #file_form_reserve_mosahebeh_Image (change)="uploadform_reserve_mosahebeh_Image(file_form_reserve_mosahebeh_Image.files)" type="file" class="form-control"  placeholder="Type here...">
            <img (click)="openModal(templateImage,Add_Record_Persone.form_reserve_mosahebeh_Image)" *ngIf="Add_Record_Persone.form_reserve_mosahebeh_Image" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{Add_Record_Persone.form_reserve_mosahebeh_Image}}"/>
          </div>
        </div>

        <br>
        <br>
        <hr>
        <br>
        <h4>Position at Behineh Farayand Azma</h4>
        <br>
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Behineh Employment Date (*)</label>
            <input formControlName="tarikh_Eshtekhdam" #tarikh_EshtekhdamInput type="text" class="form-control"  placeholder="Type here...">
            <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="tarikh_EshtekhdamInput"></ng-persian-datepicker>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Abbreviation in Behineh Farayand Azma (*)</label>
            <input formControlName="almat_Ekhtesari" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_almat_Ekhtesari().valid && get_Form_almat_Ekhtesari().touched" class="form-text text-muted MyErrorRedColor">Enter the abbreviation in Behineh Farayand Azma.</small>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Previous Experience before Behfa (Years)</label>
            <input formControlName="sabegh" type="number" class="form-control"  placeholder="Type here...">
          </div>

        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Activity Location</label>
            <select class="custom-select" formControlName="field_activity_id"  >
              <option value="0">Select</option>
              <option value="1">Inside the Laboratory</option>
              <option value="2">Outside the Laboratory</option>
              <option value="3">Inside/Outside the Laboratory</option>
              <option value="4">Administrative</option>
              <option value="5">Financial</option>
            </select>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Position</label>
            <select class="custom-select" formControlName="semat_id"  >
              <option value="0">Select</option>
              <option *ngFor="let item of DataList_Semat" [value]="item.id">{{item.title}}</option>
            </select>
          </div>
        </div>



      </form>

      <br>
      <br>
      <hr>
      <br>

      <form [formGroup]="Form_List_Hasilat_Record" (submit)="onSubmitTahsimla()" >
        <h4>Education</h4>
        <br>
        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">From Year/Month</label>
            <input formControlName="date_starrt"  type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_List_Hasilat_Record_date_starrt().valid && get_Form_List_Hasilat_Record_date_starrt().touched" class="form-text text-muted MyErrorRedColor">Enter the start year/month.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">To Year/Month</label>
            <input formControlName="date_end"   type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_List_Hasilat_Record_date_end().valid && get_Form_List_Hasilat_Record_date_end().touched" class="form-text text-muted MyErrorRedColor">Enter the end year/month.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Degree Level</label>
            <input formControlName="degree"  type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_List_Hasilat_Record_degree().valid && get_Form_List_Hasilat_Record_degree().touched" class="form-text text-muted MyErrorRedColor">Enter the degree level.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Field of Study</label>
            <input formControlName="reshteh"  type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_List_Hasilat_Record_reshteh().valid && get_Form_List_Hasilat_Record_reshteh().touched" class="form-text text-muted MyErrorRedColor">Enter the field of study.</small>
          </div>

        </div>
        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Specialization</label>
            <input formControlName="grayesh"  type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_List_Hasilat_Record_grayesh().valid && get_Form_List_Hasilat_Record_grayesh().touched" class="form-text text-muted MyErrorRedColor">Enter the specialization.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">University/Higher Education Institution</label>
            <input formControlName="uni"   type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_List_Hasilat_Record_uni().valid && get_Form_List_Hasilat_Record_uni().touched" class="form-text text-muted MyErrorRedColor">Enter the university or higher education institution.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Grade Point Average</label>
            <input formControlName="moadel"  type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_List_Hasilat_Record_moadel().valid && get_Form_List_Hasilat_Record_moadel().touched" class="form-text text-muted MyErrorRedColor">Enter the grade point average.</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">
              Upload Education Certificate
              <button (click)="Remove_uploadax_Hasilat_Image()"  type="button" *ngIf="ax_Hasilat_Image"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_ax_Hasilat_Image" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_ax_Hasilat_Image" #file_ax_Hasilat_Image (change)="uploadax_Hasilat_Image(file_ax_Hasilat_Image.files)" type="file" class="form-control"  placeholder="Type here...">
            <img (click)="openModal(templateImage,ax_Hasilat_Image)" *ngIf="ax_Hasilat_Image" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{ax_Hasilat_Image}}"/>
          </div>
        </div>

        <button  type="submit" [disabled]="!Form_List_Hasilat_Record.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Education Record </button>

      </form>

      <div class="table-responsive" *ngIf="Data_Tahsilat_List.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>From Year/Month</th>
              <th>To Year/Month</th>
              <th>Degree Level</th>
              <th>Field of Study</th>
              <th>Specialization</th>
              <th>University/Higher Education Institution</th>
              <th>Grade Point Average</th>
              <th>Education Certificate</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Data_Tahsilat_List">
             <td>{{Data_Tahsilat_List.indexOf(item)+1}}</td>
              <td>{{item.date_starrt}}</td>
              <td>{{item.date_end}}</td>
              <td>{{item.degree}}</td>
              <td>{{item.reshteh}}</td>
              <td>{{item.grayesh}}</td>
              <td>{{item.uni}}</td>
              <td>{{item.moadel}}</td>
              <td>
                <img (click)="openModal(templateImage,item.image)" *ngIf="item.image" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{item.image}}"/>
              </td>

              <td>
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Actions
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                          <a style="cursor: pointer;" (click)="RemoveTahsimla(Data_Tahsilat_List.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> Delete </a>
                      </div>
                  </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>

     <br>
     <br>
     <hr>
     <br>

     <form [formGroup]="Form_List_kari_Record" (submit)="onSubmitkari()" >
      <h4>Employment History (Past 5 Years)</h4>
      <br>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">From Year/Month</label>
          <input formControlName="date_starrt"  type="text" class="form-control"  placeholder="Type here...">
          <small *ngIf="!get_Form_List_kari_Record_date_starrt().valid && get_Form_List_kari_Record_date_starrt().touched" class="form-text text-muted MyErrorRedColor">Enter the start year/month.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">To Year/Month</label>
          <input formControlName="date_end"   type="text" class="form-control"  placeholder="Type here...">
          <small *ngIf="!get_Form_List_kari_Record_date_end().valid && get_Form_List_kari_Record_date_end().touched" class="form-text text-muted MyErrorRedColor">Enter the end year/month.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Company/Organization Name</label>
          <input formControlName="companyName"  type="text" class="form-control"  placeholder="Type here...">
          <small *ngIf="!get_Form_List_kari_Record_companyName().valid && get_Form_List_kari_Record_companyName().touched" class="form-text text-muted MyErrorRedColor">Enter the company or organization name.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Employment Type</label>
          <input formControlName="type"  type="text" class="form-control"  placeholder="Type here...">
          <small *ngIf="!get_Form_List_kari_Record_type().valid && get_Form_List_kari_Record_type().touched" class="form-text text-muted MyErrorRedColor">Enter the employment type.</small>
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Position</label>
          <input formControlName="semat"  type="text" class="form-control"  placeholder="Type here...">
          <small *ngIf="!get_Form_List_kari_Record_semat().valid && get_Form_List_kari_Record_semat().touched" class="form-text text-muted MyErrorRedColor">Enter the position.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Reason for Leaving</label>
          <input formControlName="leave"  type="text" class="form-control"  placeholder="Type here...">
          <small *ngIf="!get_Form_List_kari_Record_leave().valid && get_Form_List_kari_Record_leave().touched" class="form-text text-muted MyErrorRedColor">Enter the reason for leaving.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Phone</label>
          <input formControlName="tel"  type="text" class="form-control"  placeholder="Type here...">
          <small *ngIf="!get_Form_List_kari_Record_tel().valid && get_Form_List_kari_Record_tel().touched" class="form-text text-muted MyErrorRedColor">Enter the phone number.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Address</label>
          <input formControlName="address"  type="text" class="form-control"  placeholder="Type here...">
          <small *ngIf="!get_Form_List_kari_Record_address().valid && get_Form_List_kari_Record_address().touched" class="form-text text-muted MyErrorRedColor">Enter the address.</small>
        </div>
      </div>

      <button  type="submit" [disabled]="!Form_List_kari_Record.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Employment Record </button>

    </form>

    <div class="table-responsive" *ngIf="Data_Kari_List.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>From Year/Month</th>
            <th>To Year/Month</th>
            <th>Company/Organization Name</th>
            <th>Employment Type</th>
            <th>Position</th>
            <th>Reason for Leaving</th>
            <th>Phone</th>
            <th>Address</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Data_Kari_List">
           <td>{{Data_Kari_List.indexOf(item)+1}}</td>
            <td>{{item.date_starrt}}</td>
            <td>{{item.date_end}}</td>
            <td>{{item.companyName}}</td>
            <td>{{item.type}}</td>
            <td>{{item.semat}}</td>
            <td>{{item.leave}}</td>
            <td>{{item.tel}}</td>
            <td>{{item.address}}</td>

            <td>
              <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a style="cursor: pointer;" (click)="RemoveKari(Data_Kari_List.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> Delete </a>
                    </div>
                </div>
            </div>
            </td>

          </tr>
        </tbody>
      </table>
   </div>

    <br>
    <br>
    <hr>
    <br>

    <form [formGroup]="Form_List_Amoozeshi_Record" (submit)="onSubmitAmozeshi()" >
        <h4>Training Records</h4>
        <br>
        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">From Year/Month</label>
            <input formControlName="date_starrt"  type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_List_Amoozeshi_Record_date_starrt().valid && get_Form_List_Amoozeshi_Record_date_starrt().touched" class="form-text text-muted MyErrorRedColor">Enter the start year/month.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">To Year/Month</label>
            <input formControlName="date_end"   type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_List_Amoozeshi_Record_date_end().valid && get_Form_List_Amoozeshi_Record_date_end().touched" class="form-text text-muted MyErrorRedColor">Enter the end year/month.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Training Syllabus</label>
            <select class="custom-select" formControlName="sarFaslAmozeshi_id" (change)="ReadData_DorehAmoozeshi()">
              <option value="0">Select</option>
              <option *ngFor="let item of DataList_SarFaslAmozeshi" [value]="item.id">{{item.title}}</option>
            </select>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Training Course Title</label>
            <select class="custom-select" formControlName="dorehAmoozeshi_id">
              <option value="0">Select</option>
              <option *ngFor="let item of DataList_DorehAmoozeshi" [value]="item.id">{{item.title}}</option>
            </select>
          </div>

        </div>
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Duration (Hours)</label>
            <input formControlName="modat"  type="number" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_List_Amoozeshi_Record_modat().valid && get_Form_List_Amoozeshi_Record_modat().touched" class="form-text text-muted MyErrorRedColor">Enter the duration in hours.</small>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Training Provider</label>
            <input formControlName="bargozarKonnadeh"  type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_List_Amoozeshi_Record_bargozarKonnadeh().valid && get_Form_List_Amoozeshi_Record_bargozarKonnadeh().touched" class="form-text text-muted MyErrorRedColor">Enter the training provider.</small>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">
              Upload Education Certificate
              <button (click)="Remove_uploadax_Amoozeshi_Image()"  type="button" *ngIf="ax_Amoozeshi_Image"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_ax_Amoozeshi_Image" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_ax_Amoozeshi_Image" #file_ax_Amoozeshi_Image (change)="uploadax_Amoozeshi_Image(file_ax_Amoozeshi_Image.files)" type="file" class="form-control"  placeholder="Type here...">
            <img (click)="openModal(templateImage,ax_Amoozeshi_Image)" *ngIf="ax_Amoozeshi_Image && !ax_Amoozeshi_Image.includes('.pdf')" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{ax_Amoozeshi_Image}}"/>
          </div>
        </div>

        <button  type="submit" [disabled]="!Form_List_Amoozeshi_Record.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Training Record </button>

    </form>

    <div class="table-responsive" *ngIf="Data_Amoozeshi_List.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>From Year/Month</th>
              <th>To Year/Month</th>
              <th>Training Syllabus</th>
              <th>Training Course Title</th>
              <th>Duration (Hours)</th>
              <th>Training Provider</th>
              <th>Education Certificate</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Data_Amoozeshi_List">
             <td>{{Data_Amoozeshi_List.indexOf(item)+1}}</td>
              <td>{{item.date_starrt}}</td>
              <td>{{item.date_end}}</td>
              <td>{{item.sarFaslAmozeshiTitle}}</td>
              <td>{{item.dorehAmoozeshiTitle}}</td>
              <td>{{item.modat}}</td>
              <td>{{item.bargozarKonnadeh}}</td>
              <td>
                <a target="_blank" *ngIf="item.image && item.image.includes('.pdf')" href="{{BaseUrl}}File/Person/{{item.image}}" class="btn btn-success"><i class="fa fa-file-pdf-o"></i> PDF </a>
                <img *ngIf="item.image && !item.image.includes('.pdf')" (click)="openModal(templateImage,item.image)"  style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{item.image}}"/>
              </td>

              <td>
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Actions
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                          <a style="cursor: pointer;" (click)="RemoveAmozeshi(Data_Amoozeshi_List.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> Delete </a>
                      </div>
                  </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>

     <br>
     <br>
     <hr>
     <br>

     <form [formGroup]="Form_List_Skill_Record" (submit)="onSubmitSkill()" >
       <h4>Skill</h4>
       <br>
       <div class="row">

         <div class="form-group col-md-6">
           <label for="exampleInputEmail1">Skill</label>
           <select class="custom-select" formControlName="skill">
             <option value="0">Select</option>
             <option *ngFor="let item of DataList_Skill" [value]="item.id">{{item.title}}</option>
           </select>
         </div>
         <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Percentage</label>
          <input formControlName="percent"  type="number" class="form-control"  placeholder="Type here...">
          <small *ngIf="!get_Form_List_Skill_Record_percent().valid && get_Form_List_Skill_Record_percent().touched" class="form-text text-muted MyErrorRedColor">Enter the percentage.</small>
        </div>

       </div>

       <button  type="submit" [disabled]="!Form_List_Skill_Record.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Skill </button>

     </form>

     <div class="table-responsive" *ngIf="Data_Skill_List.length>0">
       <table class="mb-0 table table-bordered table-3 text-center table-striped">
         <thead style="background-color: #489b39; color: white;">
           <tr>
             <th>#</th>
             <th>Skill</th>
             <th>Percentage</th>
             <th>Actions</th>
           </tr>
         </thead>
         <tbody>
           <tr *ngFor="let item of Data_Skill_List">
            <td>{{Data_Skill_List.indexOf(item)+1}}</td>
             <td>{{item.skillTitle}}</td>
             <td>{{item.percennt}}</td>
             <td>
               <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                 <div class="btn-group" role="group">
                     <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                         Actions
                     </button>
                     <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                         <a style="cursor: pointer;" (click)="RemoveSkill(Data_Skill_List.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> Delete </a>
                     </div>
                 </div>
             </div>
             </td>

           </tr>
         </tbody>
       </table>
    </div>

    <br>
    <br>
    <hr>
    <br>

    <form [formGroup]="Form_List_Tahghighat_Record" (submit)="onSubmitTahghighat()" >
      <h4>Research</h4>
      <br>
      <div class="row">
        <div class="form-group col-md-3">
         <label for="exampleInputEmail1">Title</label>
         <input formControlName="title"  type="text" class="form-control"  placeholder="Type here...">
         <small *ngIf="!get_Form_List_Tahghighat_Record_title().valid && get_Form_List_Tahghighat_Record_title().touched" class="form-text text-muted MyErrorRedColor">Enter the title.</small>
       </div>
       <div class="form-group col-md-3">
        <label for="exampleInputEmail1">Date</label>
        <input formControlName="tarikh"  type="text" class="form-control"  placeholder="Type here...">
        <small *ngIf="!get_Form_List_Tahghighat_Record_tarikh().valid && get_Form_List_Tahghighat_Record_tarikh().touched" class="form-text text-muted MyErrorRedColor">Enter the date.</small>
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">Publisher</label>
        <input formControlName="nasher"  type="text" class="form-control"  placeholder="Type here...">
        <small *ngIf="!get_Form_List_Tahghighat_Record_nasher().valid && get_Form_List_Tahghighat_Record_nasher().touched" class="form-text text-muted MyErrorRedColor">Enter the publisher.</small>
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">Link</label>
        <input formControlName="link"  type="text" class="form-control"  placeholder="Type here...">
        <small *ngIf="!get_Form_List_Tahghighat_Record_link().valid && get_Form_List_Tahghighat_Record_link().touched" class="form-text text-muted MyErrorRedColor">Enter the link.</small>
      </div>

      </div>

      <button  type="submit" [disabled]="!Form_List_Tahghighat_Record.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Research Record </button>

    </form>

    <div class="table-responsive" *ngIf="Data_Tahghighat_List.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Title</th>
            <th>Date</th>
            <th>Publisher</th>
            <th>Link</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Data_Tahghighat_List">
           <td>{{Data_Tahghighat_List.indexOf(item)+1}}</td>
            <td>{{item.title}}</td>
            <td>{{item.tarikh}}</td>
            <td>{{item.nasher}}</td>
            <td>{{item.link}}</td>
            <td>
              <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a style="cursor: pointer;" (click)="RemoveTahghighat(Data_Tahghighat_List.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> Delete </a>
                    </div>
                </div>
            </div>
            </td>

          </tr>
        </tbody>
      </table>
   </div>

   <br>
    <br>
    <hr>
    <br>

    <form [formGroup]="Form_List_Document_Record" (submit)="onSubmitDocument()" >
      <h4>Document Review and Understanding</h4>
      <br>
      <div class="row">
        <div class="form-group col-md-3">
         <label for="exampleInputEmail1">Document Group</label>
         <select class="custom-select" formControlName="grpDoc_id" (change)="ReadData_DocumentTitle()">
          <option value="0">Select</option>
          <option *ngFor="let item of DataList_DocumentGroup" [value]="item.id">{{item.title}}</option>
        </select>
       </div>
       <div class="form-group col-md-3">
        <label for="exampleInputEmail1">Document Title</label>
        <select class="custom-select" formControlName="tlDoc_id">
          <option value="0">Select</option>
          <option *ngFor="let item of DataList_DocumentTitle" [value]="item.id">{{item.title}}</option>
        </select>
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">Revision Number</label>
        <input formControlName="shomareh"  type="text" class="form-control"  placeholder="Type here...">
        <small *ngIf="!get_Form_List_Document_Record_shomareh().valid && get_Form_List_Document_Record_shomareh().touched" class="form-text text-muted MyErrorRedColor">Enter the revision number.</small>
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">Approver</label>
        <input formControlName="taminKonandeh"  type="text" class="form-control"  placeholder="Type here...">
        <small *ngIf="!get_Form_List_Document_Record_taminKonandeh().valid && get_Form_List_Document_Record_taminKonandeh().touched" class="form-text text-muted MyErrorRedColor">Enter the approver.</small>
      </div>

      </div>

      <button  type="submit" [disabled]="!Form_List_Document_Record.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Document Review Record </button>

    </form>

    <div class="table-responsive" *ngIf="Data_Document_List.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Document Group</th>
            <th>Document Title</th>
            <th>Revision Number</th>
            <th>Approver</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Data_Document_List">
           <td>{{Data_Document_List.indexOf(item)+1}}</td>
            <td>{{item.grpDocTitle}}</td>
            <td>{{item.tlDocTitle}}</td>
            <td>{{item.shomareh}}</td>
            <td>{{item.taminKonandeh}}</td>
            <td>
              <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a style="cursor: pointer;" (click)="RemoveDocument(Data_Document_List.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> Delete </a>
                    </div>
                </div>
            </div>
            </td>

          </tr>
        </tbody>
      </table>
   </div>

    <br>
    <br>

    <br>
    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!InProccessing"  (click)="SubmitAddNewPerson()" type="button" [disabled]="!AddNewPerson.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
    <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-right: 5px;"><i class="fa fa-times-rectangle" ></i> Cancel </button>
    <button routerLink="/Person" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>

  </div>
</div>


<ng-template #templateImage>
  <div class="modal-header">
     <h4 class="modal-title pull-left"> View Image </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img  style="max-width: 350px;" src="{{BaseUrl}}File/Person/{{ModalimageUrl}}"/>
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Person/{{ModalimageUrl}}"   ><i class="fa fa-download"></i> Download </a>
     <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">Close</button>
  </div>
</ng-template>
